import { KeycloakConfig } from "keycloak-js";
export interface AppProps {
  BASE_URL: string;
  keycloak: KeycloakConfig;
}
// @ts-ignore
const appProps = window.configs as AppProps;
export default appProps;